import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class Adress extends Mixins(CommonView) {
    mode: number = -1;
    kurukuru: boolean = false;
    error: string = "";
    user: SBAPI.User = SBAPI.user();
    public async created() {
        if (await this.isLoginRedirect(true)) return;

        let response = await SBAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
        } else {
            response.data.email = "";
            this.user = response.data;
        }

    }

    public async edit() {
        this.mode = 0
    }

    public async check() {
        //バリデーションチェック
        this.mode = 1;
    }

    public async back() {
        let response = await SBAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
        } else {
            response.data.email = "";
            this.user = response.data;
        }

        this.mode = -1;
    }

    public async put() {
        this.kurukuru = true;
        let res = await SBAPI.UserController.putUserUsingPUT(this.user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            this.mode = 0;
        } else {
            this.mode = 2;
        }
        this.kurukuru = false;
    }
}
